import React from "react";
import LabelChip from "../Chips/LabelChip";
import { getChipImage } from "../Utils";
import { compose } from "lib/apolloClient";
import I18nHOC from "UIComponents/I18nHOC";
import classes from "./ModulesSection.scss";
import classNames from "classnames";

const ModulesSection = props => {
  const { onSelectModule, t, data = [] } = props;
  const moduleSelectionClass = classNames({
    [classes.modulesSelectionLabel]: true,
    ["text-label-3"]: true,
  });
  return (
    <div className={classes.modulesSelectionContainer} role="list">
      <div className={moduleSelectionClass}>
        {t("integration:i_m_looking_for")}
      </div>
      <div className={classes.modulesChipContainer}>
        {data.map(module => {
          const { id, title, type } = module;

          return (
            <LabelChip
              key={id}
              id={id}
              icon={getChipImage({ type })}
              label={title}
              size="xxx-small"
              onClick={() => {
                onSelectModule({ type });
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default compose(
  I18nHOC({
    resource: ["common", "teacherHomePage", "integration"],
  })
)(ModulesSection);
